import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import SetTitle from '../../utils/set_title'
import { api } from '../../utils'
import Header from '../../components/Headers/Header'
import { getDownloadFilename, triggerBlobDownload } from '../../utils/download'


export default function PEDFile() {
	SetTitle('PED Generation')
	const params = useParams()

	useEffect(() => {
		downloadData()
	}, [])

	const downloadData = () => {
		if (params?.id) {
			api.get('get-ped-generator/' + params.id, { responseType: 'blob' })
				.then((response) => {
					const contentDisposition = response.headers['content-disposition'];
					const fileName = getDownloadFilename(contentDisposition, 'ped_generator_file.xlsx')
					triggerBlobDownload(response.data, fileName)
					setTimeout(() => {
						window.location.href = '/ped-generator'
					}, 5000)
				})
				.catch((error) => {
					console.error("Download failed:", error);
					setTimeout(() => {
						window.location.href = '/ped-generator'
					}, 5000)
				});
		}
		else {
			setTimeout(() => {
				window.location.href = '/ped-generator'
			}, 1000)
		}
	}

	return (
		<Header
			iconClass="ni ni-folder-17 text-white"
			title="PED Generator"
			description="Download in corso..."
		/>
	)
}
